//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  Tabbar,
  TabbarItem,
} from 'vant'

const MENU = [
  {
    icon: 'wap-home-o',
    name: '首页',
    url: '/',
  },
  {
    icon: 'chat-o',
    name: '消息',
    url: '/message',
  },
  {
    icon: 'qr',
    name: '服务',
    url: '/service',
  },
  {
    icon: 'user-o',
    name: '我的',
    url: '/myself',
  },
]

export default {
  name: 'CBottomTabbar',

  components: {
    Tabbar,
    TabbarItem,
  },

  data () {
    return {
      menuList: MENU,
      tabActive: '',
    }
  },

  created () {
    this.tabActive = this.menuList.find((el) => el.url === this.$route.path)?.url
  },

}
